<style scoped src="../assets/css/xg.css"/>
<style scoped>
body{
  margin: 0;
}
</style>
<template>
  <div class="common-background w100">
    <div class="w1280 t80">
      <div class="xg01">
        <p class="t1">食育中国APP（食育科普）</p>
        <p class="t2">致力于良好饮食习惯的培养教育</p>
        <p class="t3">了解更多信息</p>
      </div>
      <div class="logo"><img src="../assets/img/logo.png"></div>
    </div>
  </div>

  <div style="clear: both;margin-top:40px;"></div>
  <div class="w1280 bg2">
    <p class="t4">食育中国APP（食育科普）</p>
    <p class="t5">“食育中国”这个线上平台，通过线下线上相结合的方式，不间断持续推进食育理念，普及食育知识，增强全民食品安全意识，构建食安、食育、食美可持续发展新格局。
    </p>
  </div>
  <div style="clear: both;margin-top:40px;"></div>
  <div style="clear: both;margin-top:40px;"></div>
  <div class="w1280">
    <div class="w630">
      <p class="t1">资讯频道</p>
      <p class="t2">
        食育大会，科普，辟谣，各类活动，专家圈<br/>
        </br>第二届中国食育大会旨在通过组织开展“压实各方责任 保障食品安全”主题会议、第二届中国食育膳食技能大赛（六赛区）揭晓、《餐饮业减少食物浪费实施操作指南》研讨、《食育指数研究报告》发布、校(园）长培训日及第二届中国食育画展（少儿）等活动，丰富食育形式、加强食育宣传、推动食育全面发展，增强全民食品安全意识，提高人民健康水平，弘扬传统饮食文化，营造尚俭崇信、社会共育良好氛围，构建食安、食育、食美可持续发展新格局。会上，与会嘉宾围绕校园食品安全治理，学校食品安全与营养健康工作 ，构建中国食育可持续发展体系，全媒体时代校园食品安全应急管理与舆论引导等主题展开分享和讨论。</p>
      <p class="t3">了解更多信息</p>
    </div>
    <div class="w650"><img src="../assets/img/21.jpg" style="width: 650px;"></div>

  </div>

  <div style="clear: both;margin-top:40px;"></div>
  <div class="bg3">
    <div class="w1280">
      <div class="w560"><img src="../assets/img/22.jpg"></div>
      <div class="w720">
        <p class="t1">食育课</p>
        <p class="t2">专家课，培训课，食育知识视频，行业标准法律法规</p>
        <p class="t3">了解更多信息</p>
      </div>
    </div>


  </div>

  <div style="clear: both;margin-top:40px;"></div>
  <div class="w1280">
    <div class="w630">
      <p class="t1">线下活动专题</p>
      <p class="t2">反餐饮浪费，食育小记者，传承传统饮食文化非物质文化遗产，食育进社区</p>
      <p class="t3">了解更多信息</p>
    </div>
    <div class="w650"><img src="../assets/img/23.jpg"></div>

  </div>
  <div style="clear: both;margin-top:40px;"></div>



  <div class="common-footnotes">
    <div class="w1280">
      <span>功能可用性和功能特性可能因设备类型、市场和浏览器版本的不同而有所差异。</span>
    </div>
  </div>


  <div class="common-footnotes2">
    <div class="w1280">
      <p>联系方式：wwwcfsncn@163.com</p>
     <p>
      版权所有：2023-2024 中国食品安全报 | <a href="https://www.shiyuzg.org.cn/UserAgreement.html" target="_blank">用户服务协议</a> | <a href="https://www.shiyuzg.org.cn/PrivacyStatement.html" target="_blank">隐私权政策</a> |
       产品安全  <span style="float:right;">APP备案号：京ICP备10219194号-10A &nbsp; &nbsp;京ICP备10219194号-2</span>
     </p>
    </div>
  </div>
</template>
